import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { map, tap, withLatestFrom } from 'rxjs/operators';
import { TopnavInfoService } from '../menuInterfaces/topnav-info.service';
import { merge, combineLatest } from 'rxjs';
import { IBookmarkEntry } from '../menuInterfaces/bookmark-entry.interface';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-bookmark-bar',
  templateUrl: './bookmark-bar.component.html',
  styleUrls: ['./bookmark-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookmarkBarComponent implements OnDestroy {
  subs = new SubSink();
  currentRoute$ = combineLatest([this.route.data, this.info.getExtraBreadcrumb()]).pipe(
    map(([routeData, info]) => {
      const unWindValue = this.unwind(routeData);
      return [...unWindValue, ...info];
    })
  );

  private unwindPath(item) {
    let path = item.data.path;
    if (item.data && item.data.parentMenu) {
      path = `${this.unwindPath(item.data.parentMenu)}/${path}`;
    }
    return path;
  }

  unwind = (v: any): IBookmarkEntry[] => {
    if (v === undefined) {
      return undefined;
    }

    if (v.parentMenu) {
      return [
        ...this.unwind(v.parentMenu),
        { description: v.description, path: v.bookmarkPath ? v.bookmarkPath : v.path }
      ] as IBookmarkEntry[];
    }
    if (v.data && v.data.parentMenu) {
      return [
        ...this.unwind(v.data.parentMenu),
        { description: v.data.description, path: `/${this.unwindPath(v)}` }
      ] as IBookmarkEntry[];
    }
    if (v.data) {
      return [
        { description: v.data.description, path: `/${v.bookmarkPath ? v.bookmarkPath : v.path}` }
      ] as IBookmarkEntry[];
    } else {
      return [
        { description: v.description, path: v.bookmarkPath ? v.bookmarkPath : v.path }
      ] as IBookmarkEntry[];
    }
  };

  constructor(private route: ActivatedRoute, private info: TopnavInfoService) {
    this.subs.add(this.route.data.subscribe(v => this.info.addExtraBreadCrumbData([]))); // Clear extra bookmarks on new nav
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
